export default __webpack_public_path__ + "static/media/TNS-Web-Banners4.e725de70.png";